import { FC } from 'react';
import cn from 'classnames';
import styled from 'styled-components';

import { VfoModalCommon } from '@/entities/vfo/types';
import { CaseIcon } from '@/features/vfo/components/CaseIcon';
import { COLORS } from '@/shared/constants/colors';
import { BtnClose } from '@/widgets/modals/components/BtnClose';
import { useModalsStore } from '@/widgets/modals/modals.store';

export type ModalTitleProps = {
  isMobile?: boolean;
} & VfoModalCommon;

export const ModalTitle: FC<ModalTitleProps> = (props) => {
  const { title, subTitle, isMobile } = props;
  const modals = useModalsStore();

  return (
    <Container className={cn({ isMobile })}>
      <CaseIcon {...props} size={isMobile ? 's80' : 's44'} />
      <TextWrapper>
        <Title className={cn({ isMobile })}>{title}</Title>
        {subTitle && <SubTitle className={cn({ isMobile })}>{subTitle}</SubTitle>}
      </TextWrapper>
      {!isMobile && <BtnClose onClick={modals.closeModal} />}
    </Container>
  );
};

const Container = styled.div`
  padding: 16px 24px;
  display: flex;
  align-items: center;
  gap: 16px;

  &.isMobile {
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding-bottom: 24px;
  }
`;

const Title = styled.b`
  font-size: 18px;
  line-height: 20px;
  margin-right: auto;

  &.isMobile {
    font-size: 16px;
    text-align: center;
    margin-right: 0;
  }
`;

const SubTitle = styled.span`
  color: ${COLORS.systemDark200};
  font-size: 12px;
  line-height: 16px;
  font-weight: 400;
  width: 100%;

  &.isMobile {
    text-align: center;
  }
`;

const TextWrapper = styled.div`
  display: flex;
  gap: 2px;
  align-items: center;
  flex-direction: column;
  width: 100%;
`;
